import { monthsShortOptions, seasonalityOptions } from "shared/constants";
import { Flex } from "styled-system/jsx";
import { Button, Text } from "@ttc3k/trekker";
import { useFormContext, useWatch } from "react-hook-form";
import { UpdateProfileFormValues } from "apps/directory/Operator/views";
import { SeasonalityEnum } from "gql/generated";

export const Seasonality = () => {
  const { control, setValue } = useFormContext<UpdateProfileFormValues>();
  const seasonality = useWatch({
    control: control,
    name: "seasonality",
  });

  const seasonalityVisualConfig: Record<SeasonalityEnum, string> = {
    [SeasonalityEnum.High]: "accent.blue",
    [SeasonalityEnum.Low]: "warning",
    [SeasonalityEnum.Closed]: "destructive",
  };

  const handleSelectSeasonality = (month: string, value: SeasonalityEnum) => {
    const monthPath = month.toLowerCase() as keyof typeof seasonality;
    setValue(`seasonality.${monthPath}`, value, { shouldDirty: true });
  };

  return seasonalityOptions.map((season) => (
    <Flex key={season.value} flexDir={"column"} gap={"75"}>
      <Text visual={"smallMedium"} color={"text.mid"}>
        {season.label}
      </Text>
      <Flex gap={"75"}>
        {monthsShortOptions.map((month) => {
          const monthPath =
            month.value.toLowerCase() as keyof typeof seasonality;
          return (
            <Button
              key={month.value}
              type={"button"}
              size={"sm"}
              flexBasis={1}
              flexGrow={1}
              w={"full"}
              visual={
                seasonality[monthPath] === season.value
                  ? seasonalityVisualConfig[season.value]
                  : "primary"
              }
              mode={seasonality[monthPath] === season.value ? "dark" : "light"}
              onClick={() => handleSelectSeasonality(month.value, season.value)}
            >
              {month.label}
            </Button>
          );
        })}
      </Flex>
    </Flex>
  ));
};
